import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SettingsHeader = ({ onSave, onReset, hasChanges }) => {
  return (
    <div className="bg-background border-b border-border px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
            <Icon name="Settings" size={24} color="white" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-foreground">Settings Configuration</h1>
            <p className="text-sm text-text-secondary">Customize calculation preferences and display options</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <Button
            variant="outline"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onReset}
          >
            Reset to Defaults
          </Button>
          
          <Button
            variant="default"
            iconName="Check"
            iconPosition="left"
            onClick={onSave}
            disabled={!hasChanges}
          >
            Save Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingsHeader;